import { tryOnMounted } from '@vueuse/core'
import { loadScript } from '@/utils/dom-loader'

export function useSetupTapPay(initFn: () => void = () => {}) {
  const config = useRuntimeConfig()

  tryOnMounted(() => {
    if (window.TPDirect) {
      initTPDirect()
      return
    }
    loadScript(initTPDirect, {
      id: 'tap-pay-sdk',
      src: 'https://js.tappaysdk.com/sdk/tpdirect/v5.24.0',
      defer: true,
    })
  })

  function initTPDirect() {
    const mode = config.public.CONFIG_ENV === 'prod' ? 'production' : 'sandbox'

    if (!config.public.TP_APP_ID || !config.public.TP_APP_KEY) {
      throw new Error('TapPay app id and app key are required')
    }

    window.TPDirect.setupSDK(Number(config.public.TP_APP_ID), config.public.TP_APP_KEY, mode)
    initFn?.()
  }

  return {}
}
